import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutUsComponent } from './about-us/about-us.component';
import { RouterModule, Routes } from '@angular/router';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { FAQComponent } from './faq/faq.component';
import { ActRulesComponent } from './act-rules/act-rules.component';
import { PSGActComponent } from './psgact/psgact.component';
import { FeedBackComponent } from './feed-back/feed-back.component';
import { CalendarComponent } from './calendar/calendar.component';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    AboutUsComponent,
    ContactUsComponent,
    FAQComponent,
    ActRulesComponent,
    PSGActComponent,
    FeedBackComponent,
    CalendarComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule
  
  ],
  schemas: [NO_ERRORS_SCHEMA],
  exports:[
    AboutUsComponent,
    ContactUsComponent,
    FAQComponent,
    ActRulesComponent,
    PSGActComponent,
    FeedBackComponent,CalendarComponent
  ]
})
export class FooterModule { }
